import { cn } from '@/lib/cn';
import { type LabelHTMLAttributes, forwardRef } from 'react';

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor 는 호출자가 props 로 전달, 자식은 호출자 컴포지션 책임
    <label
      ref={ref}
      className={cn('block text-sm font-medium text-foreground mb-1.5', className)}
      {...props}
    />
  ),
);
Label.displayName = 'Label';
